'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import LoadingWrapper from '../LoadingWrapper';
import * as LIST_QUERIES from '../../constants/reviews/ReviewsListQueries';
import Review from '../../records/Review';
import ReviewFilters from '../../records/ReviewFilters';
import * as RequestState from '../../constants/RequestState';
import DefaultReviewRenderer from './renderers';

const ReviewsPaginatedList = ({
  emptyState,
  onUpdateFilters,
  listAlert,
  maxWidth,
  ReviewRenderer,
  reviews,
  reviewsFetchStatus,
  reviewFilters,
  reviewsTotal,
  reviewsPerPage,
  searchTerm,
  showPagination
}) => {
  const pageCount = useMemo(() => Math.ceil(reviewsTotal / reviewsPerPage), [reviewsTotal, reviewsPerPage]);

  const renderedList = /*#__PURE__*/_jsxs("div", {
    style: {
      maxWidth
    },
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      className: "m-bottom-8",
      children: [listAlert, reviews.map((review, index) => {
        return /*#__PURE__*/_jsx(ReviewRenderer, {
          review: review,
          searchTerm: searchTerm,
          borderBottom: pageCount > 1 || reviews.size - 1 > index
        }, `${review.get('id')}_${review.get('createdAt')}`);
      })]
    }), showPagination && pageCount > 1 && /*#__PURE__*/_jsx(UIPaginator, {
      "data-test-id": "PAGE-reviews-list-select",
      maxVisiblePageButtons: 5,
      page: reviewFilters.get(LIST_QUERIES.PAGE_KEY.toLowerCase()),
      pageCount: pageCount,
      onPageChange: ({
        target: {
          value
        }
      }) => onUpdateFilters({
        textKey: LIST_QUERIES.PAGE_KEY,
        value
      })
    })]
  });

  const renderedEmptyState = emptyState || /*#__PURE__*/_jsx("div", {
    className: "m-top-4",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystemMarketplaceCore.reviews.list.emptySearch"
    })
  });

  return reviewsFetchStatus ? /*#__PURE__*/_jsx("div", {
    style: {
      position: 'relative'
    },
    children: /*#__PURE__*/_jsx(LoadingWrapper, {
      requestStatus: reviewsFetchStatus,
      showOverlay: true,
      children: reviewsTotal ? renderedList : renderedEmptyState
    })
  }) : renderedList;
};

ReviewsPaginatedList.propTypes = {
  emptyState: PropTypes.node,
  onUpdateFilters: PropTypes.func.isRequired,
  listAlert: PropTypes.node,
  maxWidth: PropTypes.number,
  ReviewRenderer: PropTypes.func.isRequired,
  reviews: ImmutablePropTypes.listOf(PropTypes.instanceOf(Review)),
  reviewsFetchStatus: PropTypes.oneOf(Object.values(RequestState)),
  reviewFilters: PropTypes.instanceOf(ReviewFilters),
  reviewsTotal: PropTypes.number.isRequired,
  reviewsPerPage: PropTypes.number.isRequired,
  searchTerm: PropTypes.string,
  showPagination: PropTypes.bool
};
ReviewsPaginatedList.defaultProps = {
  maxWidth: 750,
  reviewsPerPage: LIST_QUERIES.REVIEWS_PER_PAGE,
  ReviewRenderer: DefaultReviewRenderer,
  showPagination: true
};
export default ReviewsPaginatedList;